module.exports = __webpack_public_path__ + "img/login-no-title-background.e17888ee.jpg";